/** @jsx jsx */
import { jsx } from 'theme-ui'
import { cf2imgix } from '../../utils/cf2imgix'
import {
  BT,
  COMMUNITY_FIBRE,
  DISNEY_PLUS,
  EE,
  HYPEROPTIC,
  NOW_TV,
  PLUSNET,
  VIRGIN_MEDIA
} from '../brands/brandImages'
import Grid from '../helpers/grid'
import {
  AwardLabel,
  CupIcon,
  PeopleIcon,
  DatabaseIcon
} from '../winners/moreInfoConfig.jsx'
import MoreWinnersCard from '../winners/moreWinnersCard.jsx'
import WinnersCard from '../winners/winnersCard.jsx'
import NomineeCard from './NomineeCard.jsx'
import Heading from '../helpers/heading.jsx'
import Subheading from '../helpers/subheading.jsx'

export const PUBLIC_CHOICE = () => (
  <AwardLabel icon={PeopleIcon} title="Public choice" bgColor="#50F094" />
)

export const JUDGES_CHOICE = () => (
  <AwardLabel icon={CupIcon} title="Judges' choice" bgColor="#79C3FF" />
)

export const OPENSIGNAL_CHOICE = () => (
  <AwardLabel icon={DatabaseIcon} title="Opensignal data" bgColor="#FFA08B" />
)

const primaryNominees = [
  {
    awardlabel: <PUBLIC_CHOICE />,
    category: 'Broadband Provider of the Year',
    nomineeNames: ['BT', 'EE', 'Plusnet']
  },
  {
    awardlabel: <PUBLIC_CHOICE />,
    category: 'Alternative Broadband Provider of the Year',
    nomineeNames: ['Community Fibre', 'Hyperoptic', 'Three']
  }
]

const secondaryNominees = [
  {
    awardlabel: <PUBLIC_CHOICE />,
    category: 'Best Provider for Customer Service',
    nomineeNames: ['BT', 'EE', 'Plusnet']
  },
  {
    awardlabel: <PUBLIC_CHOICE />,
    category: 'Best Value for Money Broadband Provider',
    nomineeNames: ['Plusnet', 'Vodafone', 'EE']
  },
  {
    awardlabel: <JUDGES_CHOICE />,
    category: 'Best TV Content',
    nomineeNames: ['Disney+', 'Netflix', 'Apple TV+']
  },
  {
    awardlabel: <PUBLIC_CHOICE />,
    category: 'Most Reliable Broadband Provider',
    nomineeNames: ['BT', 'Plusnet', 'EE']
  },
  {
    awardlabel: <PUBLIC_CHOICE />,
    category: 'Most Popular Broadband Provider',
    nomineeNames: ['Sky', 'Vodafone', 'Plusnet']
  },
  {
    awardlabel: <PUBLIC_CHOICE />,
    category: 'Best Telecoms Bundle Provider',
    nomineeNames: ['Virgin Media 02', 'Sky', 'EE']
  }
]

const BroadbandTvSection = ({ children }) => (
  <div>
    <Subheading>Top broadband awards</Subheading>
    <Grid gridTemplateColumns={['1fr', '1fr', 'repeat(2, 1fr)']}>
      {primaryNominees.map((nominee) => (
        <NomineeCard key={nominee.category} {...nominee} />
      ))}
    </Grid>

    <div>
      <Subheading>More broadband and TV</Subheading>
      <Grid gridTemplateColumns={['1fr', 'repeat(2, 1fr)', 'repeat(3, 1fr)']}>
        {secondaryNominees.map((nominee) => (
          <NomineeCard key={nominee.category} {...nominee} />
        ))}
      </Grid>
    </div>
  </div>
)

export default BroadbandTvSection
